import { render, staticRenderFns } from "./FatigueForm.vue?vue&type=template&id=c202deb2&"
import script from "./FatigueForm.vue?vue&type=script&lang=js&"
export * from "./FatigueForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports